import React from 'react';
import algoliasearch from "algoliasearch";
import {Link} from 'react-router-dom';
import Moment from 'react-moment';
import 'moment-timezone';
import { isNotEmpty } from "../util/user";
import PropertyAlgolia from "./listings/PropertyAlgolia.jsx";
import BrowseFilterText from "./BrowseFilterText";
import DisplayFilters from "./DisplayFilters";
import 'rc-slider/assets/index.css';
import Slider from 'rc-slider';
import Helmet from "react-helmet";
const Range = Slider.Range;
var mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');

const toTitleCase = s => s.substr(0, 1).toUpperCase() + s.substr(1).toLowerCase()
let firstRun = true

function findWithAttr(array, attr, value) {
  for(var i = 0; i < array.length; i += 1) {
    if(array[i][attr] === value) {
      return i;
    }
  }
  return -1;
}

const formGeoData = (property) => {
  let image = property.Image;
  image = image.replace("-dev", "-prod")

  return {
    "type": "Feature",
    "properties": {
      "description": `<p>
        <img src=${image} />
        <h3><strong>${property.UnparsedAddress}</strong></h3>
        ${property.PublicRemarks.slice(0, 100)}
        <h4 class="hidden">${property.ListingId}</h4>
      </p>`,
      "icon": "marker"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [parseFloat(property.Longitude), parseFloat(property.Latitude)]
    }
  }
}

function getPreviousArray(state, filter) {
  let previousArray = state.state[filter];
  previousArray = previousArray.map((item) => {
    if (item.title == "All") {
      return {title: "All", checked: true}
    } else {
      return {title: item.title, checked: false}
    }
  });

  return previousArray;
}

function compare(a, b) {
  if (parseInt(a.objectID) < parseInt(b.objectID)) {
    return 1;
  }
  if (parseInt(a.objectID) > parseInt(b.objectID)) {
    return -1;
  }
  // a must be equal to b
  return 0;
}

export default class Browse extends React.Component {
  constructor(props) {
    super(props);
    var client = algoliasearch('PTGN8U7BAB', '1bd38ecdf030101a4cff6d2447e8de2e');

    this.state = {
      client: client,
      searchTerm: "",
      relatedTerms: "",
      results: [],
      sorting: "inserted_at_desc",
      currentPage: 0,
      pageTotal: 10,
      pageSize: 500,
      mapClassName: "map",
      priceMin: 10000,
      priceMax: undefined,
      SqFtMin: undefined,
      firstRun: true,
      SqFtMax: undefined,
      titleSideBarResults: [],
      priceSideBarResults: [],
      bedroomSideBarResults: [{title: "All", checked: true}, {title: "0", checked: false},{title: "1", checked: false},{title: "2", checked: false},{title: "3", checked: false},{title: "4", checked: false},{title: "5+", checked: false}],
      bathroomSideBarResults: [{title: "All", checked: true}, {title: "0", checked: false},{title: "1", checked: false},{title: "2", checked: false},{title: "3", checked: false},{title: "4", checked: false},{title: "5+", checked: false}],
      propertySideBarResults: [{title: "All", checked: true}, {title: "Luxury", checked: false},{title: "Condos", checked: false},{title: "Homes", checked: false},{title: "Business", checked: false}, {title: "Vacant Land", checked: false}],
      communitySideBarResults: [{title: "All", checked: true}, {title: "Ancaster", checked: false}, {title: "Brantford", checked: false}, {title: "Burlington", checked: false}, {title: "Dundas", checked: false}, {title: "Flamborough", checked: false}, {title: "Grimsby", checked: false}, {title: "Hamilton", checked: false}, {title: "Niagara", checked: false}, {title: "Oakville", checked: false}, {title: "Stoney Creek", checked: false}, {title: "Waterdown", checked: false}]
    };

    this.clearFilter = this.clearFilter.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getRelatedTerms = this.getRelatedTerms.bind(this);
    this.clearPriceFilter = this.clearPriceFilter.bind(this);
    this.clearSqFtFilter = this.clearSqFtFilter.bind(this);
    this.searchListings = this.searchListings.bind(this);
    this.increasePageNumber = this.increasePageNumber.bind(this);
    this.decreasePageNumber = this.decreasePageNumber.bind(this);
    this.handleRadioChange = this.handleRadioChange.bind(this);
    this.updateSearchTerm = this.updateSearchTerm.bind(this);
    this.updateSqFtTerm = this.updateSqFtTerm.bind(this);
    this.updatePriceFilter = this.updatePriceFilter.bind(this);
    this._setupMap = this._setupMap.bind(this);
  }

  parseQueryParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const titleParam = urlParams.get('title');
    const searchParam = urlParams.get('search') || titleParam || "";
    let minPrice = urlParams.get('min_price') || 10000
    let maxPrice = urlParams.get('max_price') || undefined
    const sortParam = urlParams.get('sort') || "";

    if (isNaN(minPrice)) {
      minPrice = 10000
    }

    if (isNaN(maxPrice)) {
      maxPrice = 1000000
    }

    if (true) {
      this.setState({
        searchTerm: searchParam,
        priceMin: minPrice,
        priceMax: maxPrice,
        sorting: sortParam,
        titleSideBarResults: []
      }, () => {
        this.searchListings();
      });
    } else {
      this.setState({
        searchTerm: searchParam
      }, () => {
        this.searchListings();
      });
    }
  }

  clearPriceFilter() {
    const state = this;

    this.setState({
      priceMax: undefined,
      priceMin: undefined
    }, () => {
      state.searchListings();
    })
  }

  clearSqFtFilter() {
    const state = this;

    this.setState({
      SqFtMax: undefined,
      SqFtMin: undefined
    }, () => {
      state.searchListings();
    })
  }

  updatePriceFilter(value) {
    let min = value[0] * 1000;
    let max = value[1] * 1000;
    const state = this;

    this.setState({
      priceMax: max,
      priceMin: min
    }, () => {
      state.searchListings();
    });
    // need to update state and search jobs
  }

  updateSqFtTerm(value) {
    let min = value[0] * 100;
    let max = value[1] * 100;
    const state = this;

    this.setState({
      SqFtMax: max,
      SqFtMin: min
    }, () => {
      state.searchListings();
    });
    // need to update state and search jobs
  }

  updateSearchTerm(e) {
    const state = this;

    this.setState({
      searchTerm: e.target.value
    }, () => {
      state.searchListings();
    })
  }

  getRelatedTerms() {

  }

  searchListings(e) {
    // really the categories get more selective as you go
    // should be removing, rather than the other way around, when not checkedboxed.
    const search = e !== undefined ? e.target.value.trim() : this.state.searchTerm;
    this.setState({ searchingFor: search });
    const state = this;

    if (this.state.client !== undefined) {
      // var index = this.state.client.initIndex(process.env.REACT_APP_ALGOLIA,);
      const stateUsed = state.state;
      // filter for facets searching for
      // let titleFacets = []
      // let titleFacets = stateUsed.communitySideBarResults.filter((filter) => filter.checked && filter.title !== "All");
      // titleFacets = titleFacets.map((filter) => filter.title).join(", ")
      // titleFacets = titleFacets.map((filter) => filter.title).join(", ")
      // titleFacets = titleFacets.substring(0, titleFacets.length - 2);

      // let priceFacets = stateUsed.priceSideBarResults.filter((filter) => filter.checked && filter.title !== "All");
      let priceFacets = [`ListPrice>=${state.state.priceMin}`]
      if (state.state.priceMax != undefined && state.state.priceMin != undefined) {
        priceFacets = [`ListPrice>=${state.state.priceMin}`, `ListPrice<=${state.state.priceMax}`]
      }

      let sqFtFacets = []
      if (state.state.SqFtMax != undefined && state.state.SqFtMin != undefined) {
        sqFtFacets = [`BuildingAreaTotal>=${state.state.SqFtMin}`, `BuildingAreaTotal<=${state.state.SqFtMax}`]
      }
      // priceFacets = priceFacets.map((filter) => "price:" + filter)

      let propertyFacets = stateUsed.propertySideBarResults.filter((filter) => filter.checked && filter.title !== "All");
      let titleFacets = propertyFacets.map((filter) => filter.title).join(", ")

      let bathroomFacets = stateUsed.bathroomSideBarResults.filter((filter) => filter.checked && filter.title !== "All");
      bathroomFacets = bathroomFacets.map((filter) => "BathroomsTotal:" + filter.title)

      let bedroomFacets = stateUsed.bedroomSideBarResults.filter((filter) => filter.checked && filter.title !== "All");
      bedroomFacets = bedroomFacets.map((filter) => "BedroomsTotal:" + filter.title)

      let communityFacetsMain = stateUsed.communitySideBarResults.filter((filter) => filter.checked && filter.title !== "All");
      let communityFacets = communityFacetsMain.map((filter) => "City:" + filter.title)
      // let communityFacetsSubDivision = communityFacetsMain.map((filter) => "SubdivisionName:" + filter.title)

      let facetFilters = [].concat.apply([], bathroomFacets);
      facetFilters = [].concat.apply(facetFilters, bedroomFacets);
      facetFilters = [].concat.apply(facetFilters, communityFacets);
      // facetFilters = [].concat.apply(facetFilters, communityFacetsSubDivision);
      // facetFilters = [].concat.apply(facetFilters, communityFacets);
      let priceAndsqFtFacets = [].concat.apply(priceFacets, sqFtFacets);

      if (this.state.searchTerm != undefined && this.state.searchTerm != "") {
        let middleJoin = ", ";
        if (titleFacets.length == 0) {
          middleJoin = "";
        }
        // titleFacets = `${this.state.searchTerm}`;
        titleFacets = `${propertyFacets}${middleJoin}${this.state.searchTerm}`;
      }

      let indexName = process.env.REACT_APP_ALGOLIA;

      if (this.state.sorting === "newest") {
        indexName = "inserted_at_desc"
      }

      if (this.state.sorting === "oldest") {
        indexName = "inserted_at_asc"
      }

      if (this.state.sorting === "cheapest") {
        indexName = "list_price_asc"
      }

      if (this.state.sorting === "expensive") {
        indexName = "list_price_desc"
      }

      const listingQuery = {
        indexName: indexName,
        params: {
          query: titleFacets,
          page: this.state.currentPage, // algolia starts at 0 for pages
          hitsPerPage: this.state.pageSize,
          numericFilters: priceAndsqFtFacets,
          attributesToRetrieve: '*',
          attributesToHighlight: [],
          facetFilters: [facetFilters]
        }
      };

      console.log('listingQuery', listingQuery)

      this.state.client.search([listingQuery]).then((data) => {
        let results = (data.results[0].hits || []).filter((result) => isNotEmpty(result.UnparsedAddress));

        results = results.sort(compare);
        state.setState({
          results: results.slice(0, this.state.pageSize),
          pageTotal: data.results[0].nbPages
        });

        this._setupMap(results);
      });
    }
  }

  increasePageNumber() {
    // const amount = this.state.currentPage == 0 ? 2 : 1;
    const amount = 1;
    const state = this;
    this.setState({currentPage: this.state.currentPage + amount}, () => {
      state.searchListings();
    });
  }

  decreasePageNumber() {
    // const amount = this.state.currentPage == 0 ? 2 : 1;
    const amount = 1;
    let newPage = this.state.currentPage - amount
    newPage = newPage < 0 ? 0 : newPage
    const state = this;
    this.setState({currentPage: newPage}, () => {
      state.searchListings();
    });
  }

  handleRadioChange(field, map, e) {
    const state = this;

    if (field === "All") {
      this.clearFilter(map)
      return;
    }

    let mapped = this.state[map];
    let res = this.state[map].map(l => Object.assign({}, l));
    let index = findWithAttr(res, "title", field)
    res[index].checked = !res[index].checked
    const any_checked = res.filter((item) => item.checked && item.title !== "All").length > 0

    if (any_checked) {
      // make all unchecked
      res[0].checked = false;
    } else {
      res[0].checked = true;
    }

    state.setState({[map]: res}, () => {
      state.searchListings();
    });
  }

  componentDidMount() {
    this.parseQueryParams();
    this.searchListings();
  }

  _setupMap(results) {
    let state = this
    mapboxgl.accessToken = 'pk.eyJ1IjoicmFrc29uaWJzIiwiYSI6IjZ0TFFlUEUifQ._wLBBR-FcaQuIK-tnfU7-w';

    let firstResult = results[0];
    if (firstResult !== undefined && firstResult.Longitude !== "") {
      let center;

      let length = results.length
      let all_longs = results.reduce((a, b) => a + b.Longitude, 0)
      let avg_long = all_longs / length

      let all_lats = results.reduce((a, b) => a + b.Latitude, 0)
      let avg_lat = all_lats / length
      center = [parseFloat(avg_long), parseFloat(avg_lat)];

      var mapOptions = {
        container: "mapId",
        style: "mapbox://styles/mapbox/streets-v11",
        center: center,
        zoom: 10
      };

      state.setState({firstRun: false})
      firstRun = false

      var map = new mapboxgl.Map(mapOptions);

      map.on('load', function () {
        let geoData = results.reduce((acc, property) => {
          return [...acc, formGeoData(property)]
        }, [])
        // map.addSource("places", fullGeoData);

        map.addLayer({
          "id": "places",
          "type": "symbol",
          "source": {
            "type": "geojson",
            "data": {
              "type": "FeatureCollection",
              "features": geoData
            }
          },
          "layout": {
            "icon-image": "{icon}-15",
            "icon-allow-overlap": true
          }
        });
      });

      map.on('click', 'places', function (e) {
        var coordinates = e.features[0].geometry.coordinates.slice();
        // let id = e.features[0].properties.description.slice("<h4 class=\"hidden\">")[0]
        var myRe = /<h4 class=\"hidden\">(.*?)<\/h4>/g;
        var myArray = myRe.exec(`${e.features[0].properties.description}`);
        var myId = myArray[1];
        var description = `<a href="/listings/${myId}">${e.features[0].properties.description}</a>`;

        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
        }

        new mapboxgl.Popup()
        .setLngLat(coordinates)
        .setHTML(description)
        .addTo(map);
      });

      map.on('mouseenter', 'places', function () {
        map.getCanvas().style.cursor = 'pointer';
      });

      // Change it back to a pointer when it leaves.
      map.on('mouseleave', 'places', function () {
        map.getCanvas().style.cursor = '';
      });
    } else {
      // hide map?
      this.setState({
        mapClassName: "map hidden"
      })
    }
  }

  componentWillMount() {
    this.parseQueryParams();
  }

  clearFilter(filter) {
    const state = this;

    let map = {
      titleSideBarResults: getPreviousArray(state, "titleSideBarResults"),
      bathroomSideBarResults: getPreviousArray(state, "bathroomSideBarResults"),
      bedroomSideBarResults: getPreviousArray(state, "bedroomSideBarResults"),
      communitySideBarResults: getPreviousArray(state, "communitySideBarResults"),
      priceMax: undefined,
      priceMin: undefined,
      SqFtMax: undefined,
      SqFtMin: undefined
    }

    if (filter !== undefined) {
      let previousArray = getPreviousArray(state, filter);

      map = {
        [filter]: previousArray
      }
    }

    this.setState(map, () => {
      state.searchListings();
    });
  }

  handleChange(field, e) {
    const state = this;
    this.setState({[field]: e.target.value}, () => {
      state.searchListings();
    });
  }

  render() {
    let results = []
    const state = this;

    let priceText = "All"
    if (this.state.priceMin !== undefined) {
      let maxPrice = `$${parseInt(10000000).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
      if (this.state.priceMax !== undefined) {
        maxPrice = `$${parseInt(this.state.priceMax).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
      }
      priceText = `$${parseInt(this.state.priceMin).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} - ${maxPrice}`;
    }

    let sqFtText = "All"
    if (this.state.SqFtMin !== undefined) {
      sqFtText = `${this.state.SqFtMin} - ${this.state.SqFtMax}`;
    }

    results = state.state.results;

    return (
      <div className="profile-pane no-border browse-page real-browse-page">
        <Helmet>
          <title>Hamilton Homes - Search for your properties</title>
          <meta name="description" content="We offer the most detail, geopgraphically specific, updated search for properties in the GTHA!"/>
          <meta name="keywords" content="hamilton,homes,for,sale,search,condos,luxury,business"/>

          <meta property="og:url" content="https://besthamiltonhouses.com/browse"/>
          <meta property="og:title" content="Hamilton Homes - Search"/>
          <meta property="og:description" content="We offer the most detail, geopgraphically specific, updated search for properties in the GTHA!"/>
        </Helmet>

        <div className="left-side filters">

        </div>

        <div className="right-side">
          <div className={this.state.mapClassName} id="mapId"></div>

          <div className="results-ctn">
            <h2 className="heading">Listings</h2>

            <div className="ctn-jobs">
              <div className="all-jobs full-height">
                <div className="row all-jobs-row">
                  <div className="container" id="jobs-container">
                    {results.map((result, index) =>
                      <span key={"job-result" + result.objectID} className="job-ctn">
                        <PropertyAlgolia result={result} />
                      </span>
                      )}

                      <h3 className="right-text">
                        <span>View Page: {state.state.currentPage + 1} of {state.state.pageTotal + 1} Pages</span>
                        <br />
                        <span className="yellow-font" onClick={this.decreasePageNumber}>Prev Page</span> - <span className="yellow-font" onClick={this.increasePageNumber}>Next Page</span>
                        <br />
                        <br />
                        <br />
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    )
  }
};
